import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from "@/mixins/packageTableMixins";
import samplingCustom from "./components/samplingCustom";
import deviceInfo from "./components/deviceInfo";
import pvData from "./components/pvData";
import realtimeData from "./components/realtimeData";
import refreshCustom from "./components/refreshCustom";
import DistributionLog from "../devicedistribution/distributionLog1";
import Control from "../control/control.vue";
import Historyrouter from "../historyrouter/historyrouter";
import AlermDes from "../../alarmManage/alermDes/alermDes2.vue";
import { ChartPie, ChartItemBar, ChartLineStackMul2 } from "_c/charts";
import { config_caiyang_pinglv, web_issue_order, upup_firmware, progress_firmware, did_config_pass, get_firmware_info } from "@/api/jingxiaoshang";
import * as echarts from "echarts";
export default {
  name: 'MechanismManage',
  mixins: [packageTableMixins],
  data: function data() {
    return {
      is_dingji: localStorage.getItem('is_dingji'),
      progress_text: '',
      password: null,
      passwordTypeIcon: 'ios-eye',
      passwordType: 'password',
      firmware_list: [],
      booleanModel: false,
      booleanValue: null,
      interval: null,
      shuaxin: null,
      timeoutId: null,
      requestTime: null,
      chans: null,
      chansAll: null,
      did: null,
      currDidTab: '0',
      details_data: ['设备信息', '实时数据', 'PV数据', '固件升级', '参数设置', '历史记录', '告警数据', '历史轨迹', '密码管理']
    };
  },
  components: {
    ChartPie: ChartPie,
    ChartItemBar: ChartItemBar,
    ChartLineStackMul2: ChartLineStackMul2,
    DistributionLog: DistributionLog,
    AlermDes: AlermDes,
    Control: Control,
    Historyrouter: Historyrouter,
    deviceInfo: deviceInfo,
    realtimeData: realtimeData,
    pvData: pvData
  },
  methods: {
    startPrinting: function startPrinting(val) {
      this.restartTimer();
      this.booleanValue = val || this.booleanValue;

      if (this.booleanValue == 0) {
        this.booleanModel = true;
      }
    },
    modal7Ok: function modal7Ok() {
      localStorage.setItem("shuaxin", 60 * 60);
      this.$Message.success(this.$t("设置成功"));
      this.booleanModel = false;
      this.restartTimer();
    },
    modal7cancel: function modal7cancel() {
      this.booleanModel = false;
      this.restartTimer();
    },
    restartTimer: function restartTimer() {
      clearInterval(this.interval);
      this.initializeTimer();
    },
    initializeTimer: function initializeTimer() {
      var _this2 = this;

      var refreshRate = 300 * 1000;
      var valTime = localStorage.getItem("shuaxin");

      if (valTime == 3600) {
        return;
      }

      this.interval = setInterval(function () {
        _this2.startPrinting("0"); // 触发对话框逻辑

      }, refreshRate);
    },
    change_tab2: function change_tab2(tab) {
      this.currDidTab = tab;

      if (this.$route.query.tabs) {
        this.$router.push({
          path: this.$route.path,
          // 保留当前路径
          query: _objectSpread({}, this.$route.query, {
            // 保留其他查询参数
            tabs: tab // 更新 tabs 参数

          })
        });
      }

      this.check_new();
    },
    refresh: function refresh() {
      var vm = this;
      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "5px"
            }
          }, // "刷新频率"
          vm.$t("刷新频率")), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h("Divider", {
            style: {
              margin: "8px 0"
            }
          }), h(refreshCustom, {
            ref: "refreshCustom",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false,
              shuaxin: localStorage.getItem("shuaxin") || 60,
              parent_code: "0",
              parent_name: "无"
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.refreshCustom;
          obj.checkForm().then(function (res) {
            if (res) {
              // console.log(obj.formModel)
              vm.shuaxin = obj.formModel.refresh_value;
              vm.$Message.success("设置成功");
              vm.$Modal.remove();
              clearInterval(vm.dingshi);
              vm.dingshi = setInterval(vm.iotdatalastget, vm.shuaxin * 1000);
              localStorage.setItem("shuaxin", vm.shuaxin); //     vm.init()
            }
          }); // let _this = this;
          // let obj = this.$refs.refreshCustom;
          // obj.checkForm().then(res => {
          // if (res) {
          //   area_add({...obj.formModel}).then(res => {
          //   let msg=res.errorMsg;
          //   if (res.result === 0) {
          //     let msg=res.errorMsg;
          //     vm.$Message.success(msg);
          //     vm.$Modal.remove();
          //     vm.init()
          //   } else {
          //   vm.$Message.error(msg);
          //     _this.buttonLoading = false;
          //   }
          // });
          // } else {
          //     _this.buttonLoading = false;
          // }
          //  });
        }
      };
      this.$Modal.confirm(config);
    },
    sampling: function sampling() {
      var _this3 = this;

      //   alert(sampling)
      //  return;
      var vm = this;
      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "5px"
            }
          }, _this3.$t("采样频率设置")), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h("Divider", {
            style: {
              margin: "8px 0"
            }
          }), h(samplingCustom, {
            ref: "samplingCustom",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false,
              parent_code: "0",
              parent_name: "无",
              did: vm.did,
              caiyang_pinglv: _this3.caiyang_pinglv
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.samplingCustom;
          obj.checkForm().then(function (res) {
            if (res) {
              //this.caiyang_pinglv=obj.formModel.sampling_value
              config_caiyang_pinglv(_objectSpread({}, obj.formModel)).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  //console.log('aaa',obj.formModel.sampling_value)
                  var _msg = res.errorMsg;
                  vm.$Message.success(_msg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    web_shuaxin: function web_shuaxin() {
      this.did = this.$route.query.did;

      if (this.$route.query.tabs) {
        this.currDidTab = this.$route.query.tabs;
      }
    },
    shauxinAll: function shauxinAll() {
      var _this4 = this;

      web_issue_order({
        did: this.did,
        tab_check: '4g',
        device_type: 2
      }).then(function (res) {});
      setTimeout(function () {
        _this4.web_shuaxin();
      }, 6000);
    },
    startTimer: function startTimer() {
      var _this5 = this;

      this.shuaxin = localStorage.getItem("shuaxin") || 60;
      var shuaxintime = this.shuaxin * 1000;
      this.clearTimer();
      this.timeoutId = setInterval(function () {
        _this5.web_shuaxin();
      }, shuaxintime);
    },
    clearTimer: function clearTimer() {
      if (this.timeoutId) {
        clearInterval(this.timeoutId);
        this.timeoutId = null;
      }
    },
    savepassword: function savepassword() {
      var _this6 = this;

      did_config_pass({
        pass: this.password,
        did: this.did
      }).then(function (res) {
        var msg = res.errorMsg;

        if (res.result === 0) {
          _this6.$Message.success(msg);
        } else {
          _this6.$Message.error(msg);
        }
      });
    },
    swicthPassword: function swicthPassword() {
      if (this.passwordTypeIcon === "ios-eye") {
        this.passwordTypeIcon = "ios-eye-off";
        this.passwordType = "text";
      } else if (this.passwordTypeIcon === "ios-eye-off") {
        this.passwordTypeIcon = "ios-eye";
        this.passwordType = "password";
      }
    },
    uploadFirmware: function uploadFirmware(dp_chan) {
      var did = this.did;
      this.result_firmware = [];
      var vm = this;
      var config = {
        title: "升级",
        loading: true,
        content: "您确定要升级通道" + dp_chan + "的固件吗？",
        onOk: function onOk() {
          var _this = this;

          upup_firmware({
            did: did,
            dp_chan: dp_chan
          }).then(function (res) {
            if (res.result === 0) {
              _this.$Message.success(res.errorMsg);

              vm.$Modal.remove();
              _this.buttonLoading = false; // this.getFirmwareInfo()
              //拉取进度

              vm.firmware_list[dp_chan].is_jindu = 1;
              vm.firmware_list[dp_chan].is_shengji = 0; // vm.progress_dingshi = setInterval(vm.progress, 5000);

              vm.progress_dingshi = setInterval(function () {
                vm.progress(dp_chan);
              }, 3000);
            } else {
              _this.$Message.error(res.errorMsg);

              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    //检测新的固件版本
    check_new: function check_new(chan_id) {
      var _this7 = this;

      //alert(123)
      //get_firmware_info
      // console.log("aaa",this.did)
      //获取设备信息
      get_firmware_info({
        did: this.did
      }).then(function (res) {
        _this7.tableLoading = false;
        _this7.tableDataList = [];

        if (res.result === 0) {
          //this.details_data = res.body;
          // if (res.body.firmware == "") {
          //   this.$Message.error("暂无可更新固件");
          // }
          if (res.body.firmware && res.body.firmware.length > 0) {
            //this.is_update=res.body.firmware[0].is_update
            if (_this7.is_update === 0) {//  this.$Message.info("已经是最新版本")
            } else {} //  this.$Message.success("检测出可升级的固件")
              //console.log("res.body.firmware.firmware_ver.multi_rom",res.body.firmware.firmware_ver.multi_rom)


            console.log("res.body.firmware", res.body.firmware);
            _this7.firmware_list = res.body.firmware;

            if (chan_id == 0 || chan_id > 0) {
              _this7.$Message.success(_this7.$t("检测成功"));
            }
          } else {
            _this7.is_update = 0; //  this.$Message.error("暂无可升级的固件")
          }
        } else {
          _this7.tableDataList = [];
          _this7.getPageTotal = 0;

          _this7.$Message.error(res.errorMsg);
        }
      });
    },
    progress: function progress(dp_chan) {
      var _this8 = this;

      var did = this.did;
      progress_firmware({
        did: did,
        dp_chan: dp_chan
      }).then(function (res) {
        if (res.result === 0) {
          if (res.body.jindu == 100) {
            setTimeout(function () {
              _this8.check_new();
            }, 15000); // 15000 毫秒 = 15 秒
          } // //拉取进度
          //this.is_jindu = 1;


          _this8.firmware_list[dp_chan].is_jindu = 1;

          if (res.body.jindu == 100) {
            clearInterval(_this8.progress_dingshi);
          }

          _this8.firmware_list[dp_chan].progress_percent = res.body.jindu;
          _this8.firmware_list[dp_chan].progress_text = res.body.ext_code;
          console.log(_this8.result_firmware);

          if (_this8.result_firmware.length >= 6) {
            var last = _this8.result_firmware.length - 1;

            if (_this8.result_firmware[last] == _this8.result_firmware[last - 1] && _this8.result_firmware[last] == _this8.result_firmware[last - 2] && _this8.result_firmware[last] == _this8.result_firmware[last - 3] && _this8.result_firmware[last] == _this8.result_firmware[last - 4] && _this8.result_firmware[last] == _this8.result_firmware[last - 5] && _this8.result_firmware[last] == _this8.result_firmware[last - 6]) {
              clearInterval(_this8.progress_dingshi); //this.$Message.error("固件升级超时，升级失败")

              _this8.$Notice.open({
                title: "升级通知",
                desc: "通道" + dp_chan + "固件升级超时，升级失败",
                duration: 0
              });

              _this8.check_new();
            }
          }

          _this8.result_firmware.push(res.body.jindu);
        } else {
          _this8.$Message.error(res.errorMsg); //this.is_jindu = 0;


          _this8.firmware_list[dp_chan].is_jindu = 0; //this.is_shengji = 1

          _this8.firmware_list[dp_chan].is_shengji = 1; //this.progress_percent = 0;

          _this8.firmware_list[dp_chan].progress_percent = 0; //this.progress_text = "";

          _this8.firmware_list[dp_chan].progress_text = "";
          clearInterval(_this8.progress_dingshi);
        } //这里
        // if (this.progress_percent < 100) {
        //   this.progress_percent += 10;
        // }

      });
    }
  },
  mounted: function mounted() {
    this.web_shuaxin();
    this.startTimer();
    this.initializeTimer();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
  },
  destroyed: function destroyed() {}
};